import { ProductApi } from '../../infrastructure/api';
import { Product } from '../../domain/entities';

export class LoadProductsUseCase {
    async execute(vehicleId: number, token: string): Promise<Product[]> {
        return await ProductApi.fetchByVehicleId(vehicleId, token);
    }
}

